module.exports = __webpack_public_path__ + "img/activity_5_civil_splash.14b0ea71.jpg";